export default __webpack_public_path__ + "static/media/PotProKit_PickYourOwn_6in_8_main.d5876cf6.png";